var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcoLineRed(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0h800v800H0V0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M566.667,200h166.667v66.667h-66.667v433.333c0,18.409-14.924,33.333-33.333,33.333H166.667c-18.409,0-33.333-14.924-33.333-33.333v-433.333h-66.667v-66.667h166.667v-100c0-18.409,14.924-33.333,33.333-33.333h266.667c18.409,0,33.333,14.924,33.333,33.333v100ZM600,266.667H200v400h400v-400ZM300,366.667h66.667v200h-66.667v-200ZM433.333,366.667h66.667v200h-66.667v-200ZM300,133.333v66.667h200v-66.667h-200Z",
    fill: "#de0909"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcoLineRed);
export default __webpack_public_path__ + "static/media/trash-ico-line-red.f3913538a6a4a0dab773e99111736685.svg";
export { ForwardRef as ReactComponent };